module.exports = __webpack_public_path__ + "img/available.37b05adb.svg";